import {
  EditorState,
  ContentState,
  convertFromRaw,
  convertFromHTML,
} from 'draft-js'

// for use in a SettingTextEditor component's constructor method. Input is props
// (derived from redux state) and output is values you can assign to local
// React component state.
export default (body, subject, { isInDB, isEmail }) => {
  let bodyState, subjectState

  if (isInDB) {
    if (!isEmail) {
      bodyState = prepInitState_plainText(body, warn)
    } else {
      bodyState = prepInitState_richText(body, warn)
      subjectState = prepInitState_plainText(subject, warn)
    }
  } else if (!isEmail) {
    bodyState = EditorState.createEmpty()
  } else {
    bodyState = EditorState.createEmpty()
    subjectState = EditorState.createEmpty()
  }

  return { bodyState, subjectState }
}

function prepInitState_plainText(body, handleTypeErr) {
  const type = typeof body

  switch (type) {
    case 'string': {
      return EditorState.createWithContent(ContentState.createFromText(body))
    }
    case 'object': {
      // just assuming it was sent over as an ImmutableJS object
      if (body.rawState) {
        // TODO: verify that ReactRTE can fallback to DraftJS methods
        return EditorState.createWithContent(convertFromRaw(body.rawState))
      }
      return EditorState.createWithContent(
        ContentState.createFromText(body.text),
      )
    }
    default: {
      handleTypeErr(`Can not handle body: ${body} of type ${type}`)
    }
  }
}

function prepInitState_richText(body, handleTypeErr) {
  const type = typeof body

  switch (type) {
    case 'string': {
      const htmlBlocks = convertFromHTML(body)
      const contentState = ContentState.createFromBlockArray(
        htmlBlocks.contentBlocks,
        htmlBlocks.entityMap,
      )
      return EditorState.createWithContent(contentState)
    }
    case 'object': {
      if (body.rawState) {
        return EditorState.createWithContent(convertFromRaw(body.rawState))
      }
      const htmlBlocks = convertFromHTML(body.text)
      const contentState = ContentState.createFromBlockArray(
        htmlBlocks.contentBlocks,
        htmlBlocks.entityMap,
      )
      return EditorState.createWithContent(contentState)
    }
    default: {
      handleTypeErr(`Can not handle body: ${body} of type ${type}`)
    }
  }
}

function warn(errMsg) {
  console.warn(errMsg)
}



// WEBPACK FOOTER //
// ./src/services/draft-state/incoming.js